module.exports = __webpack_public_path__ + "static/Verne0-b2d9fb27b4977dddc8c96d1d52e2f6fd.gif";